import React, {useState} from 'react';
import styles from './rating.module.css'
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import { styled } from '@mui/material/styles';
import Rating from '@mui/material/Rating';

import { ReactComponent as Heart } from '../../assets/img/heart.svg'
import { ReactComponent as FulledHeart } from '../../assets/img/fulledHeart.svg'
import {useDispatch} from "react-redux";
import {addRating} from "../Tickets/ticketSlice";

const StyledRating = styled(Rating)({
    '& .MuiRating-icon': {
        marginRight: '10px'
    },
    '& .MuiRating-iconEmpty': {
        color: '#EF2E25'
    },
    '& .MuiRating-iconFilled': {
        color: '#EF2E25',
    },
    '& .MuiRating-iconHover': {
        color: '#EF2E25',
    },
});
const HeartRating = ({id, raiting}) => {
    const [rating, setRating] = useState(raiting)
    const dispatch = useDispatch()
    const handleChange = (e) => {
        if (rating) {
            dispatch(addRating({id, rating: e.target.value /1}))
        }
    }
    return (
        <div style={{marginTop: '20px'}}>
            <StyledRating
                onChange={handleChange}
                size={'large'}
                label={{color: '#000000'}}
                name="customized-color"
                defaultValue={raiting? raiting : 0}
                icon={<FulledHeart  fontSize="inherit" />}
                emptyIcon={<Heart fontSize="inherit" />}
            />
        </div>
    );
};

export default HeartRating;